import { useEffect, useRef, useState } from 'react'
import Icon from './icons.jsx'
import { useApp } from '../context/AppContext.jsx'

export default function ClientSwitcher() {
  const {
    availableClients,
    selectedClient,
    setSelectedClient,
  } = useApp() || {}
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    function onClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener('mousedown', onClick)
    return () => document.removeEventListener('mousedown', onClick)
  }, [])

  if (!availableClients || availableClients.length <= 1) return null

  // Scope agregado faz sentido sempre que há >1 cliente acessível — o guard
  // acima já garante isso. Vale para TODOS os modos, inclusive client_only
  // (usuário convidado que recebeu acesso a vários clients via
  // user_client_access), que deve ter as mesmas opções do owner.

  const isAggregate = selectedClient === null

  const handleSelectClient = (id) => {
    if (id !== selectedClient?.id) {
      void setSelectedClient(id)
    }
    setOpen(false)
  }

  const handleSelectAggregate = () => {
    if (!isAggregate) {
      void setSelectedClient(null)
    }
    setOpen(false)
  }

  const buttonLabel = isAggregate
    ? 'Todas as contas'
    : selectedClient?.name || 'Selecionar conta'

  return (
    <div className="client-switcher" ref={ref} style={{ position: 'relative' }}>
      <button
        type="button"
        className="client-switcher-btn Todas as Contas"
        onClick={() => setOpen((v) => !v)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '6px 10px',
          fontSize: 13,
          maxWidth: 240,
        }}
        title="Trocar conta"
      >
        <span
          aria-hidden
          style={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0 }}
        >
          <Icon n="ads" s={14} />
        </span>
        <span
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {buttonLabel}
        </span>
        <Icon n={open ? 'chevron_u' : 'chevron_d'} s={12} />
      </button>
      {open && (
        <div
          className="client-switcher-dropdown"
          style={{
            position: 'absolute',
            top: 'calc(100% + 6px)',
            right: 0,
            minWidth: 260,
            maxWidth: 'calc(100vw - 32px)',
            background: 'var(--card, #fff)',
            border: '1px solid var(--border, #e5e5e7)',
            borderRadius: 8,
            boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
            padding: 4,
            zIndex: 50,
          }}
        >
          <>
            <button
              type="button"
              className={`client-switcher-option ${isAggregate ? 'active' : ''}`}
              onClick={handleSelectAggregate}
              style={{
                width: '100%',
                textAlign: 'left',
                padding: '8px 10px',
                fontSize: 13,
                borderRadius: 6,
                background: isAggregate ? 'var(--bg-muted, #f5f5f7)' : 'transparent',
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                fontWeight: isAggregate ? 600 : 400,
              }}
              title="Ver dados agregados de todas as contas"
            >
              <span
                aria-hidden
                style={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0 }}
              >
                <Icon n="ads" s={14} />
              </span>
              <span style={{ flex: 1 }}>Todas as contas</span>
            </button>
            <div
              aria-hidden
              style={{
                height: 1,
                background: 'var(--border, #e5e5e7)',
                margin: '4px 0',
              }}
            />
          </>
          {availableClients.map((c) => {
            const isCurrent = !isAggregate && c.id === selectedClient?.id
            return (
              <button
                type="button"
                key={c.id}
                className={`client-switcher-option ${isCurrent ? 'active' : ''}`}
                onClick={() => handleSelectClient(c.id)}
                style={{
                  width: '100%',
                  textAlign: 'left',
                  padding: '8px 10px',
                  fontSize: 13,
                  borderRadius: 6,
                  background: isCurrent ? 'var(--bg-muted, #f5f5f7)' : 'transparent',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 8,
                  fontWeight: isCurrent ? 600 : 400,
                }}
              >
                <span
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {c.name}
                </span>
                {c.is_self && (
                  <span
                    style={{
                      fontSize: 10,
                      padding: '2px 6px',
                      borderRadius: 999,
                      background: 'var(--bg-muted, #f0f0f3)',
                      color: 'var(--ter, #6e6e73)',
                    }}
                  >
                    próprio
                  </span>
                )}
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}
